import { CmsValue } from 'core/type/BootstrapConfig.types';
import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import {
    selectActivityIdFromSelectedOffer,
    selectIsShowDateChipNotification,
    selectOfferGroupIdFromSelectedOfferGroup,
} from 'component/page/detail/store/availabilitySelectorIndex';

interface StateProps {
    cms: CmsValue;
    isShowNotification: boolean;
    selectedOfferId: number;
    activityId: number | undefined;
}

export type Props = StateProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectIsShowDateChipNotification,
    selectOfferGroupIdFromSelectedOfferGroup,
    selectActivityIdFromSelectedOffer,
    (cms, isShowNotification, selectedOfferId, activityId): StateProps => {
        return { cms, isShowNotification, selectedOfferId, activityId };
    },
);
